<template>
  <div>
    <v-container>
      <v-row align="center" justify="center" class="mobileHeader mt-5">
        <v-col cols="9" class="pr-0">
          <img src="@/assets/horizontal.png" width="100%" style="max-height: 36px" />
        </v-col>
        <v-col cols="3" class="text-right">
          <img src="@/assets/bookmark.png" width="16px" class="mr-5" @click="goTo('/salvos')" />
          <img src="@/assets/share@1,5x.svg" width="16px" v-if="webShareApiSupported" class="fakeLink" @click="shareViaWebShare()" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    webShareApiSupported() {
      return navigator.share
    },
  },
  methods: {
    goTo(item) {
      this.$router.push(item)
    },
    shareViaWebShare() {
      // navigator.share({
      //   title: 'Conecta Meu Futuro',
      //   text: 'Uma plataforma que vai te conectar ou reconectar com a sua jornada universitária. Embarca nessa jornada com a gente.',
      //   url: 'https://conectaunisinos.paimlab.com.br/',
      // })
      window.open(
        'https://wa.me/?text=%2aConecta%20Meu%20Futuro%2e%2a%20Uma%20plataforma%20que%20vai%20te%20conectar%20ou%20reconectar%20com%20a%20sua%20jornada%20universitária%2E%20Embarca%20nessa%20jornada%20com%20a%20gente%3A%20unisinos%2Ebr%2fconectameufuturo',
        '_BLANK'
      )
    },
  },
}
</script>

<style>
.icon-mobile {
  height: 20px !important;
}

.mobileHeader {
  z-index: 200;
}
</style>
